import {
  Button,
  Card,
  Collapse,
  ControlGroup,
  Elevation,
  NonIdealState,
  Spinner,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { apiCallPost, apiUrl } from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import { withRouter } from "react-router";
import cogoToast from "cogo-toast";
import MultiSelectWrapper from "../utils/MultiSelectWrapper";
import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";
import ReactPlayer from "react-player/lazy";

class SxVideo extends React.Component {
  state = {
    collapsed: true,
    isLoading: true,
    isError: false,
    tags: [],
  };
  componentDidMount() {
    this.getVideoDetails();
  }
  specialities = [
    "Cataract",
    "Glaucoma",
    "Cornea",
    "Retina",
    "Oculoplasty",
    "Neuro-Ophthalmology",
    "Uveitis",
    "Refractive",
    "General",
  ];
  getVideoDetails = async () => {
    try {
      this.setState({ isLoading: true });
      let res = await apiCallPost(
        `/booking-sx/${this.props.authStore.prefix}/SxVideoUpload/getBySxId`,
        {
          relatedSxId: this.props.data._id,
        }
      );
      this.setState({ ...res, isLoading: false, isError: false });
    } catch (err) {
      this.setState({ isError: true, isLoading: false });
      cogoToast.error("Error getting video details");
    }
  };
  renderUploadArea = () => {
    return (
      <FilePond
        allowMultiple={false}
        dropOnPage={true}
        labelIdle={`${
          this.state.videoUploaded ? "Replace Video" : "Upload Video"
        }`}
        name={`${this.state._id}`}
        server={{
          url: apiUrl,
          process: {
            url:
              `/booking-sx/${this.props.authStore.prefix}/SxVideoUpload/upload/` +
              this.state._id,
            method: "POST",
          },
          revert: null,
          restore: null,
          load: null,
          fetch: null,
        }}
        key={`${this.state._id}`}
        ref={(ref) => (this.pond = ref)}
        onprocessfiles={() => {
          cogoToast.success("Video uploaded");
          this.getVideoDetails();
        }}
        credits={false}
        onerror={() => {
          cogoToast.error("Error uploading video");
        }}
        onupdatefiles={(fileItems) => {
          this.setState({
            files: fileItems.map((fileItem) => fileItem.file),
          });
        }}
      />
    );
  };
  renderVideoPlayer = () => {
    if (!this.state.videoUploaded) {
      return (
        <NonIdealState
          icon="video"
          title="No Video"
          description="No video has been uploaded for this surgery."
        />
      );
    }
    return (
      <div>
        <ReactPlayer url={this.state.videoPsUrl} controls={true} />
      </div>
    );
  };
  renderVideoDetails = () => {
    return (
      <div>
        <ControlGroup>
          <Tag minimal large intent="primary">
            Video Tags
          </Tag>
          <MultiSelectWrapper
            items={this.specialities}
            selectedItems={this.state.tags}
            showSelectProp={true}
            onChange={(items) => this.setState({ tags: items, changed: true })}
          />
          <Button
            disabled={this.state.changed === false}
            icon="endorsed"
            onClick={() => this.updateVideoDetails()}
            loading={this.state.isUpdatingVideo}
            intent="success"
          />
        </ControlGroup>
      </div>
    );
  };
  updateVideoDetails = async () => {
    try {
      this.setState({ isUpdatingVideo: true });
      let res = await apiCallPost(
        `/booking-sx/${this.props.authStore.prefix}/SxVideoUpload/update`,
        {
          _id: this.state._id,
          doc: this.state,
        }
      );
      this.setState({ ...res, isUpdatingVideo: false, changed: false });
      cogoToast.success("Video details updated");
    } catch (err) {
      this.setState({ isUpdatingVideo: false, changed: true });
      cogoToast.error("Error updating video details");
    }
  };
  renderBasedOnLifecycle = () => {
    return (
      <>
        <Collapse isOpen={this.state.collapsed}>
          {" "}
          <Card elevation={Elevation.FOUR}>
            <Tag large intent="primary" style={{ marginBottom: "10px" }}>
              Surgical Video
            </Tag>

            <Button
              icon="double-chevron-down"
              outlined
              onClick={() => this.setState({ collapsed: false })}
            />
          </Card>
        </Collapse>{" "}
        <Collapse isOpen={!this.state.collapsed}>
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag large fill intent="primary">
                Surgical Video
              </Tag>
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: true })}
              />
            </ControlGroup>
            <div
              style={
                this.props.canEdit
                  ? {}
                  : {
                      "pointer-events": "none",
                      opacity: 0.5,
                    }
              }
            >
              {this.renderVideoDetails()}
              <br />
              {this.renderVideoPlayer()}
              <br />
              {this.renderUploadArea()}
            </div>
          </Card>
        </Collapse>
      </>
    );
  };
  render() {
    if (this.state.isError) {
      return (
        <NonIdealState
          icon="warning-sign"
          title="Error"
          description="There was an error loading the video."
        />
      );
    }
    if (this.state.isLoading) {
      return (
        <NonIdealState
          icon={<Spinner size={50} />}
          title="Loading..."
          description="Loading surgical video data..."
        />
      );
    }
    return <div>{this.renderBasedOnLifecycle()}</div>;
  }
}

export default inject("authStore")(observer(withRouter(SxVideo)));
